import { useEffect, useRef } from "react";

export const useInterval = (callback, delay, immediate = false) => {
  const cbRef = useRef(noop);

  useEffect(() => {
    cbRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!immediate || !delay) {
      return;
    }
    cbRef.current();
  }, [immediate, delay]);

  useEffect(() => {
    if (!delay) return;
    const timer = () => {
      cbRef.current();
    };
    const id = setInterval(timer, delay);
    return () => {
      clearInterval(id);
    }
  }, [delay]);
};

const noop = () => {};